import { useTourCitySelectedTag } from './useTourCitySelectedTag';
import { useTourCityTagsAdapters } from './useTourCityTagsAdapters';
import { useTourCityTagsFiltering } from './useTourCityTagsFiltering';
import { useTourCityVisibleTags } from './useTourCityVisibleTags';
import type { Ref } from 'vue';
import type { CityTag, RegionTagUrls } from '@/shared/api/experience';

export function useTourCityRubrics(
  cityTags: Ref<CityTag[] | undefined>,
  isMobile: Ref<boolean>,
  citySlug: Ref<string>,
) {
  const context = computed(() => 'tours' as keyof RegionTagUrls);

  const { selectedValue, cachedSelectedValue } = useTourCitySelectedTag(cityTags, context, citySlug);
  const { popupTags, rubricsTags } = useTourCityTagsFiltering(cityTags);
  const { popupTagsMapped, rubricsAdapters } = useTourCityTagsAdapters(rubricsTags, popupTags, context, citySlug);
  const { visibleTags } = useTourCityVisibleTags(rubricsAdapters, selectedValue, isMobile);

  return {
    selectedValue,
    cachedSelectedValue,
    popupTagsMapped,
    rubricsAdapters,
    visibleTags,
  };
}
